import React, { useEffect, useState } from "react";
import { TbLayoutGrid } from "react-icons/tb";
import { AiOutlineUnorderedList } from "react-icons/ai";
import TopArtistGridView from "./TopArtistGridView";
import TopArtistListView from "./TopArtistListView";
function TopArtistAll() {
  const [topActive, setTopactive] = useState("grid");
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <section>
      <div className="mainContainer pt-4">
        <div className="d-flex align-items-center headdrop ForSmallUpcoming">
          <h3 className="dropdownGap">upcoming Collection drops</h3>
          <div className="dropdowns">
            <button
              className="dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              All categories{" "}
              <span>
                <img src="Vector (9).png" alt="arrow" className="mb-2" />
              </span>
            </button>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a className="dropdown-item" href="#">
                All caltegories
              </a>
              <a className="dropdown-item" href="#">
                Featured Collection
              </a>
              <a className="dropdown-item" href="#">
                Top artists
              </a>
              <a className="dropdown-item" href="#">
                recommended Collection
              </a>
              <a className="dropdown-item" href="#">
                Trending Collection
              </a>
              <a className="dropdown-item" href="#">
                In game Collection
              </a>
              <a className="dropdown-item" href="#">
                popular Categories
              </a>
              <a className="dropdown-item" href="#">
                Traditional
              </a>
              <a className="dropdown-item" href="#">
                anime / fantacy
              </a>
              <a className="dropdown-item" href="#">
                character NFT’s
              </a>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between collectionDetailbox mt-sm-4 mt-2">
          <div className="d-flex">
            <div className="filterimg">
              <img src="filter-list 1.png" alt="filter" />
            </div>
            <div className="searchCollection">
              <img src="search (1).png" alt="search" />
              <input
                type="search"
                placeholder="Search Collections and Creators"
              />
            </div>
          </div>
          <div className="d-flex ">
            <div className="dropdown ">
              <button
                className="dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                games{" "}
                <span>
                  <img
                    src="Vector (10).png"
                    alt="arrow"
                    className="mb-1 ms-3"
                  />
                </span>
              </button>
              <div
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <a className="dropdown-item" href="#">
                  All caltegories
                </a>
                <a className="dropdown-item" href="#">
                  Featured Collection
                </a>
                <a className="dropdown-item" href="#">
                  Top artists
                </a>
                <a className="dropdown-item" href="#">
                  recommended Collection
                </a>
              </div>
            </div>

            <div className="listGrid">
              <div
                className={`iconHolder ${
                  topActive === "grid" ? "listActive" : ""
                }`}
                onClick={() => setTopactive("grid")}
              >
                <TbLayoutGrid />
              </div>
              <div
                className={`iconHolder ${
                  topActive === "grid" ? "" : "listActive"
                }`}
                onClick={() => setTopactive("list")}
              >
                <AiOutlineUnorderedList />
              </div>
            </div>
          </div>
        </div>
        <div className="pt-4">
          {topActive === "grid" ? (
            <TopArtistGridView />
          ) : (
            <div>
              <TopArtistListView />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default TopArtistAll;
